import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

// Async thunk
export const fetchCityData = createAsyncThunk(
  "cities/fetchCityData",
  async () => {
    const response = await axios.get(`${apiUrl}/api/cities/indexify`);
    return response.data;
  }
);

const citiesSlice = createSlice({
  name: "cities",
  initialState: {
    citiesData: {},
    loading: false,
    error: null,
  },  
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCityData.fulfilled, (state, action) => {
        state.loading = false;
        state.citiesData = action.payload; // store API response
      })
      .addCase(fetchCityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default citiesSlice.reducer;
